export default __webpack_public_path__ + "static/media/ico_lock.ab5da2de.svg";